export default __webpack_public_path__ + "static/media/logo_planet_wi.bcac28b9.svg";